import React, { ReactElement } from 'react';
import ChoiceOption from '@/components/ChoiceOption';
import './TrafficLight.scss';
import {
  ChoiceDataType,
  ChoiceOptionType,
  TrafficLightPropType,
} from '@/modules/types/choice';

const TrafficLight = ({
  choices,
  isDisabled,
  handler,
}: {
  choices: ChoiceOptionType[];
  isDisabled: boolean;
  handler: (answer: string) => void;
}): ReactElement => {
  const selectTrafficLight = (choice: ChoiceDataType) => {
    const useUUID = choice.choiceMetadata?.useUUID || false;
    const selectedChoice =
      choice.lcmsReferenceIds === undefined ||
      Object.keys(choice.lcmsReferenceIds).length <= 0 ||
      useUUID
        ? choice.id
        : `${choice.lcmsReferenceIds.id}`;
    handler(selectedChoice);
  };

  const trafficLight = ['red', 'yellow', 'green'];

  return (
    <div id="TrafficLight">
      <div className="traffic-light--wrapper">
        <div className="light">
          {choices
            .sort(
              (a, b) =>
                (a.data.choiceMetadata?.position || 0) -
                (b.data.choiceMetadata?.position || 0),
            )
            .map((item: TrafficLightPropType, index: number) => (
              <div key={index} className={`light-${trafficLight[index]}`}>
                <ChoiceOption
                  className={`${trafficLight[index]}-option`}
                  iconRight={false}
                  title=""
                  description={item.data.content}
                  onClick={() => {
                    selectTrafficLight(item.data);
                  }}
                  isDisabled={isDisabled}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default TrafficLight;
